import React from 'react'
import { useCmsBlock } from 'lib/core/hooks'
import { CMS_BLOCK } from 'app/sofia/resources/constants'
import { CmsContentWrap } from './components/Styled'

interface CmsBlockData {
  id: string
  updatedAt?: number
  content: string
  isSuccess: boolean
  isFailure: boolean
  isFirstLoad: boolean
}

export const PrivacyPolicy =() => {
  const staticBlockID = CMS_BLOCK.PRIVACY_POLICY
  const staticBlock = useCmsBlock({
    id: staticBlockID,
    isLazy: false

  }) as CmsBlockData

  return (
    <CmsContentWrap>
      {staticBlock.content && (
        <div
          dangerouslySetInnerHTML={{
            __html: staticBlock?.content ?? ''
          }}
        />
      )}
    </CmsContentWrap>
  )
}
